import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homesix-banner',
  templateUrl: './homesix-banner.component.html',
  styleUrls: ['./homesix-banner.component.scss']
})
export class HomesixBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
